/* eslint-disable max-len */
/* eslint-disable eqeqeq */
import moment from 'moment';
import 'moment-range';
import React, { useEffect, useState } from 'react';
import DashboardHeaderWithFilters from '../../../components/DashboardHeaderWithFilters';
import GifLoader from '../../../components/Loading/GifLoader';
import useFilterMethods from '../../../customHooks/useFilterMethods';
import useToast from '../../../customHooks/useToast';
import { GET_REFERRAL_BAR_ANALYTICS, GET_REFERRAL_DONUT_ANALYTICS } from '../../../graphql/admin_queries';
import useCustomQuery from '../../../network/useCustomQuery';
import RewardBarChart from './RewardBarChart';
import Styles from './RewardChart.module.scss';
import RewardCollection from './RewardCollections';

const RewardChart = () => {
  const Toast = useToast();
  const [dateType, setDateType] = useState('THIS_YEAR');
  const [barCategory, setBarCategory] = useState([]);
  const [barSeries, setBarSeries] = useState([]);
  const [getReferralDonut, referralDonutLoading, referralDonut] = useCustomQuery({
    query: GET_REFERRAL_DONUT_ANALYTICS,
    onError: () => {},
    onData: () => {},
  });

  const [getReferralBar, referralBarLoading, referralBar] = useCustomQuery({
    query: GET_REFERRAL_BAR_ANALYTICS,
    onError: () => {},
    onData: () => {},
  });
  const getReferralFunc = async (result) => {
    getReferralDonut({
      variables: {
        from: result.fromDate,
        to: result.toDate,
      },
    });
  };

  const getReferralBarFunc = async (result:string) => {
    getReferralBar({
      variables: {
        filter: result,
      },
    });
  };

  const onFilterSubmit = (result) => {
    getReferralFunc(result);
    getReferralBarFunc(dateType);
  };

  function shortenMonthName(fullMonth) {
    const monthsMap = {
      January: 'Jan',
      February: 'Feb',
      March: 'Mar',
      April: 'Apr',
      May: 'May',
      June: 'Jun',
      July: 'Jul',
      August: 'Aug',
      September: 'Sep',
      October: 'Oct',
      November: 'Nov',
      December: 'Dec',
    };

    const shortenedMonth = monthsMap[fullMonth];

    // If the provided month is not valid, return the original string
    return shortenedMonth || fullMonth;
  }

  useEffect(() => {
    const getSeries = referralBar?.getReferralsBarAnalytics?.map((list:any) => list?.total);
    setBarSeries(getSeries);
  }, [referralBar]);

  useEffect(() => {
    const getCategories = referralBar?.getReferralsBarAnalytics?.map((list:any) => {
      if (dateType === 'LAST_7_DAYS') {
        return moment(list?.day).format('ddd, DD/MM');
      }
      return list?.day || shortenMonthName(list?.month);
    });
    setBarCategory(getCategories);
  }, [referralBar]);

  const {
    filterObj,
  } = useFilterMethods({
    allowedFilters: ['alternativeDateRange'],
    defaultUrl: '/rewards/statistics?page=1',
    cb: onFilterSubmit,
    Toast,
  });

  return (
    <div className={Styles.wrapper}>
      <div className={Styles.wrapper__header}>
        <DashboardHeaderWithFilters
          title="Referral statistics"
          filterObj={filterObj}
          dateType="alternativeDateRange"
          setDateLabel={(dateLable:any) => setDateType(dateLable?.value)}
          // exportObj={{
          //   handleExport,
          // }}
        />
      </div>
      <div className="row">
        <div className={`col-lg-5 ${Styles.wrapper__donut}`}>

          {
            referralDonutLoading ? <GifLoader /> : referralDonut && <RewardCollection payload={referralDonut?.getReferralDonutAnalytics} />
          }

        </div>
        <div className="col-lg-7">
          {
            referralBarLoading ? <div className={Styles.wrapper__bar}><GifLoader /></div> : referralBar && <RewardBarChart barSeries={barSeries} barCategory={barCategory} />
          }

        </div>
      </div>

    </div>
  );
};

export default RewardChart;
